module.exports = __webpack_public_path__ + "static/media/checked.10bb8897.png";